module.exports = __webpack_public_path__ + "static/img/xueye.fe7a3c8e.png";